import { elapsedSeconds, formatRelativeTime, formatShortDate } from 'Pods/ThreeDStudio/Shared/Utils/formatDate'

// Below a week a like is stamped relatively ("6d ago"), above it with a short
// absolute date ("22 Jul").
const RELATIVE_WINDOW_SECONDS = 604800

// Time stamp for a row in the likers list: relative inside the week ("2h ago"),
// a short absolute date beyond it ("22 Jul"). The unit abbreviation and its
// spacing are per-locale, so the whole relative string comes from i18n rather
// than being assembled here. `now` is injectable for tests.
export default function formatLikedAt(iso, { t, locale = 'en', now = Date.now() } = {}) {
  const elapsed = elapsedSeconds(iso, now)

  if (elapsed === null) {
    return ''
  }

  if (elapsed < RELATIVE_WINDOW_SECONDS) {
    return formatRelativeTime(iso, {
      now,
      formatUnit: (unit, amount) => t(`likers.relativeTime.${unit}`, { count: amount }),
    })
  }

  return formatShortDate(iso, locale, { now })
}
